var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tour", { attrs: { steps: _vm.steps, callbacks: _vm.callbacks } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }